import { render, staticRenderFns } from "./TeamClouds.vue?vue&type=template&id=56a6612a&scoped=true"
var script = {}
import style0 from "./TeamClouds.vue?vue&type=style&index=0&id=56a6612a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6612a",
  null
  
)

export default component.exports